import React from 'react';

import { Nullable, SimpleObject } from '@clearverify/types';

import { VerificationRequestProcessingContext } from './VerificationRequestProcessingContext';

export const VerificationRequestProcessingProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isSubmitting, setSubmitting] = React.useState<boolean>(false);
  const [activeRequestResponsesMap, setActiveRequestResponsesMap] = React.useState<
    SimpleObject<boolean>
  >({});

  const startSubmitting = React.useCallback(() => setSubmitting(true), []);
  const stopSubmitting = React.useCallback(() => setSubmitting(false), []);

  const startVerifierResponding = React.useCallback(
    (requestId: string) =>
      setActiveRequestResponsesMap((state: SimpleObject<boolean>) => ({
        ...state,
        [requestId]: true,
      })),
    [],
  );

  const stopVerifierResponding = React.useCallback(
    (requestId: string) =>
      setActiveRequestResponsesMap((state: SimpleObject<boolean>) => ({
        ...state,
        [requestId]: false,
      })),
    [],
  );

  const isVerifierResponding = React.useCallback(
    (inboxItemId: Nullable<string>) => {
      if (!inboxItemId) return false;
      return activeRequestResponsesMap[inboxItemId] || false;
    },
    [activeRequestResponsesMap],
  );

  const resetState = React.useCallback(() => {
    setSubmitting(false);
    setActiveRequestResponsesMap({});
  }, []);

  const contextValue = React.useMemo(() => {
    return {
      isSubmitting,
      startSubmitting,
      stopSubmitting,

      isVerifierResponding,
      startVerifierResponding,
      stopVerifierResponding,

      resetState,
    };
  }, [
    isSubmitting,
    isVerifierResponding,
    resetState,
    startSubmitting,
    startVerifierResponding,
    stopSubmitting,
    stopVerifierResponding,
  ]);

  return (
    <VerificationRequestProcessingContext value={contextValue}>
      {children}
    </VerificationRequestProcessingContext>
  );
};
